import {
	updateEmailId,
	updateFirstName,
	updateIsAuthenticated,
	updateLastName,
	updatePhoneNumber,
	updateStripeCustomerId,
	updateUserId,
	updatePlanTierId,
	updateCurrentPlanStartDate,
} from "../store/userDetailsSlice";

import axiosRequestInterceptor from "../interceptor/axiosAPIRequestInterceptor";
import { logger } from "./logger";
import store from "../store/store"; // Import your Redux store

// Adjust the import path based on your project structure

export const performLogout = async () => {
	try {
		await axiosRequestInterceptor.post("/users/logout", {});
		const dispatch = store.dispatch; // Access the Redux dispatch function

		dispatch(updateIsAuthenticated(false));
		dispatch(updateFirstName(""));
		dispatch(updateLastName(""));
		dispatch(updateEmailId(""));
		dispatch(updatePhoneNumber(""));
		dispatch(updateUserId(""));
		dispatch(updateStripeCustomerId(""));
		dispatch(updatePlanTierId(""));
		dispatch(updateCurrentPlanStartDate(""));
		if (window.location.pathname !== "/") {
			window.location.href = "/";
		}
	} catch (error) {
		logger.log("Logout failed:", error);
	}
};
